<template>
  <div class="container">
    <div class="page">
      <div class="header_nav">
        <div>
          <router-link class="router_link" to="/Home/UPR">合作厂商一</router-link>
        </div>
        <div>合作厂商二</div>
      </div>
      <div class="partner_img">
        <div class="img">
          <img src="../assets/images/cjt/1.png">
        </div>
        <div class="img">
          <img src="../assets/images/cjt/2.png">
        </div>
        <div class="img">
          <img src="../assets/images/cjt/3.png">
        </div>
      </div>
      <div class="section">
        <div>
          <div class="title">简介
            <div></div>
          </div>
          <div class="intro">
            某连接器有限公司于1998年创立，占地1000平方米，主要是对外开放连接器模具，60%供出口，40%内销。2003年创建连接器品牌。2006年便已经获得ISO 9001质量管理体系认证。2009年获得美国UL/cUL认证，2012年获得德国TUV认证，为产品出口奠定基础。
          </div>
        </div>
        <div>
          <div class="title">主要优势
            <div></div>
          </div>
          <div class="culture">
            <ul>
              <li>
                <div class="icon">
                  <span>交</span>
                  <span>期价格</span>
                </div>
              </li>
              <li>
                <div class="icon">
                  <span>品</span>
                  <span>质</span>
                </div>
              </li>
              <li>
                <div class="icon">
                  <span>其</span>
                  <span>他增值服务</span>
                </div>
              </li>
              <li>
                <div class="icon">
                  <span>弹</span>
                  <span>性运营</span>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div>
          <div class="title">主要客户
            <div></div>
          </div>
          <div>
            <img src="../assets/images/cjt/4.png">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {

    }
  }
}
</script>

<style scoped>
/* 二级导航栏 */
.header_nav>div:nth-child(2) {
  background:rgba(0,0,0,1);
  color: #fff;
}
.header_nav>div:nth-child(1):hover {
  color: #a3a3a3;
  cursor: pointer;
}
/* 主要优势 */
.culture {
  padding: 0 42px;
}
.icon {
  width: 140px;
  height: 140px;
  margin-bottom: 60px;
}
.icon>span {
  line-height: 140px;
}
</style>